module.exports = __webpack_public_path__ + "static/media/new-search.a5b68140.svg";